export default __webpack_public_path__ + "static/media/store-9.192db922.png";